import Button from "@mui/material/Button";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Alert, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useApiHook from "../../hooks/useApiHook";
import { useDeletePatientModal, usePatientRefresh } from "../../store/modal-context";
import ResponsiveDialog from "../_atoms/ResponsiveDialog";

const DeletePatientDialog = () => {
    const { isOpen, closeModal, payload } = useDeletePatientModal();
    const { refreshPatients } = usePatientRefresh();
    const { response, makeRequest, loading, error } = useApiHook();
    const [submitRequested, setSubmitRequested] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setSubmitRequested(false);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen || !submitRequested || !response || response.state !== 'success') {
            return;
        }

        refreshPatients();
        if (payload?.onSuccess) {
            payload.onSuccess();
        }

        setSubmitRequested(false);
        closeModal();
    }, [closeModal, isOpen, payload, refreshPatients, response, submitRequested]);

    const onConfirmHandler = () => {
        if (!payload?.patientId) {
            return;
        }

        setSubmitRequested(true);
        makeRequest('/folder/delete', 'post', { folderId: payload.patientId });
    };

    return (
        <ResponsiveDialog
            minWidth="unset"
            minHeight="unset"
            title={(
                <Stack direction="row" alignItems="center" spacing={1}>
                    <DeleteForeverIcon fontSize="medium" />
                    <Typography variant="h6">Elimina Paziente</Typography>
                </Stack>
            )}
            isOpen={isOpen}
            onClose={closeModal}
            actions={(
                <>
                    <Button
                        size="large"
                        variant="contained"
                        color="error"
                        onClick={onConfirmHandler}
                        disabled={loading}
                    >
                        Si
                    </Button>
                    <Button size="large" onClick={closeModal}>
                        No
                    </Button>
                </>
            )}
        >
            <Stack width="100%" spacing={2}>
                <Typography width="100%" textAlign="left" variant="body1">
                    Vuoi davvero eliminare il paziente <strong>{payload?.patientName}</strong>?
                </Typography>
                <Typography width="100%" textAlign="left" variant="body2" sx={{ opacity: 0.65 }}>
                    I file contenuti verranno spostati nella root.
                </Typography>
                {error && (
                    <Alert severity="error">
                        Impossibile eliminare il paziente. Riprova.
                    </Alert>
                )}
            </Stack>
        </ResponsiveDialog>
    );
};

export default DeletePatientDialog;
